/** В URL только фильтры; выбранная точка и полномочия проверяются отдельно сервером. */
export interface PortalCatalogLocation {
  q: string
  categoryId?: number
  page: number
  skuPage: number
}

function integer(raw: string | null, minimum: number, maximum: number): number | undefined {
  if (raw === null || !/^\d+$/.test(raw)) return undefined
  const value = Number(raw)
  return Number.isSafeInteger(value) && value >= minimum && value <= maximum ? value : undefined
}

export function parsePortalCatalogLocation(search: string): PortalCatalogLocation {
  const params = new URLSearchParams(search)
  return {
    q: (params.get('q') ?? '').trim().slice(0, 160),
    categoryId: integer(params.get('categoryId'), 1, Number.MAX_SAFE_INTEGER),
    page: integer(params.get('page'), 0, 100_000) ?? 0,
    skuPage: integer(params.get('skuPage'), 0, 100_000) ?? 0,
  }
}

export function catalogSearchString(filters: PortalCatalogLocation, product = false): string {
  const params = new URLSearchParams()
  if (filters.q) params.set('q', filters.q)
  if (filters.categoryId !== undefined) params.set('categoryId', String(filters.categoryId))
  if (filters.page) params.set('page', String(filters.page))
  if (product && filters.skuPage) params.set('skuPage', String(filters.skuPage))
  return params.size ? `?${params.toString()}` : ''
}
